export const TRIAL_SIGNUP_ENDPOINTS = {
  VALIDATE_EMAIL: '/app_support/email/validate',
  VERIFY: '/companies/trial/verify',
  REGISTER: '/companies/trial/register',
  PANELS: '/companies/trial/panels',
  COUNTRIES: '/companies/trial/countries',
};

export const TRIAL_SIGNUP_QUERY_KEYS = {
  VALIDATE_EMAIL: 'TRIAL_SIGNUP_VALIDATE_EMAIL',
  VERIFY: 'TRIAL_SIGNUP_VERIFY',
  REGISTER: 'TRIAL_SIGNUP_REGISTER',
  PANELS: 'TRIAL_SIGNUP_PANELS',
  COUNTRIES: 'TRIAL_SIGNUP_COUNTRIES',
};
